import React, { useContext } from 'react'
import classNames from 'classnames'
import { SipContext } from '~/service/SipConn'
import Timer from './common/Timer'
import { Link, useLocation } from 'react-router-dom'
import { ChatContext } from '~/service/chatConn'
// import { TicketListManagerContext } from '~/service/TicketListManager'
import { InternalChatManagerContext } from '~/service/InternalChatManager'

const Menu: React.FC = ({}) => {
  const { pathname } = useLocation()

  const { activeEstablishedCall, incomingCall } = useContext(SipContext)
  const { unread } = useContext(ChatContext)
  // const { unreadTickets } = useContext(TicketListManagerContext)
  const { unreadChats } = useContext(InternalChatManagerContext)

  if (!window.c.menuVisible) {
    return null
  }

  return (
    <div className="menu">
      {window.c.phoneEnabled && (
        <MenuButton
          icon="far fa-phone"
          label={
            !activeEstablishedCall || pathname.startsWith('/phone') ? (
              // 'Telefon'
              intl.formatMessage({ id: 'menu / phone' })
            ) : (
              <Timer initial={activeEstablishedCall.establishedAt} />
            )
          }
          path="/phone"
          className={classNames({ 'is-calling': incomingCall })}
        />
      )}

      {window.c.chatEnabled && (
        <MenuButton
          icon="far fa-messages"
          label={intl.formatMessage({ id: 'menu / chat' })}
          path="/chat"
          badge={unread}
        />
      )}

      {window.c.internalChat && (
        <MenuButton
          icon="far fa-message-arrow-down"
          label={intl.formatMessage({ id: 'menu / internal chat' })}
          path="/internal-chat"
          badge={unreadChats}
        />
      )}

      {!window.c.itsm && (
        <MenuButton
          icon="far fa-user-friends"
          label={intl.formatMessage({ id: 'menu / clients' })}
          path="/clients"
        />
      )}

      {/* <MenuButton
        icon="far fa-ticket"
        label={intl.formatMessage({ id: 'menu / tickets' })}
        path="/tickets"
        badge={unreadTickets}
      /> */}

      {!window.c.itsm && (
        <MenuButton
          icon="far fa-history"
          label={intl.formatMessage({ id: 'menu / calls' })}
          path="/calls"
        />
      )}

      {!window.c.itsm && (
        <MenuButton
          icon="far fa-bullhorn"
          label={intl.formatMessage({ id: 'menu / campaigns' })}
          path="/campaigns"
        />
      )}

      {/* <MenuButton
        icon={<Calendar />}
        label={intl.formatMessage({ id: 'menu / calendar' })}
        path="/calendar"
      /> */}

      {!window.c.itsm && (
        <MenuButton
          icon="far fa-user-edit"
          label={intl.formatMessage({ id: 'menu / to describe' })}
          path="/to-describe"
        />
      )}
    </div>
  )
}

// const Calendar: React.FC = ({}) => {
//   return <div className="menu-calendar">{new Date().getDate()}</div>
// }

type ButtonProps = {
  path: string
  icon: string | React.ReactElement
  label: string | React.ReactElement
  className?: string
  badge?: number
}

const MenuButton: React.FC<ButtonProps> = ({
  icon,
  label,
  path,
  className,
  badge,
}) => {
  const { pathname } = useLocation()

  return (
    <Link
      to={path}
      className={classNames(
        { 'is-active': pathname.startsWith(path) },
        className
      )}
    >
      {typeof icon == 'string' ? <span className={icon} /> : icon}

      {label}

      {typeof badge != 'undefined' ? (
        <div className="menu-badge">{badge > 0 ? badge : null}</div>
      ) : null}
    </Link>
  )
}

export default Menu
